import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import {
  LeftSide,
  ModalBody,
  ModalContent,
  ModalHeader,
  ProfessionInfoModalStyles,

  TextContainer,
  TitleBox,
} from './ProfessionInfoModal.styles';
import infoIcon from '../../../../assets/redesign_icons/info-icon.svg';

function CondominioNobisModal({
  setShowModal,

}) {
  const closeModal = () => {
    setShowModal(false);
  };

  return (
    <ProfessionInfoModalStyles>
      <ModalBody>
        <ModalHeader>
          <LeftSide>
            <FontAwesomeIcon
              fontSize={34}
              icon={faTimes}
              cursor="pointer"
              onClick={() => closeModal()}
            />
            <TextContainer>
              <TitleBox>
                <img src={infoIcon} alt="" />
                <h3>Informazione</h3>
              </TitleBox>
              <p>Qui puoi controllare le informazioni su questa offerta.</p>
            </TextContainer>
          </LeftSide>

        </ModalHeader>
        <ModalContent>
          <p className="fw-bold">Danni ai beni</p>
          <p className="mt-3">La Società indennizza l'Assicurato dei costi necessari per la ricostruzione del fabbricato - escluso il valore dell'area distrutto o danneggiato, ad esempio da:</p>
          <p>- incendio</p>
          <p>- fulmine</p>
          <p>- scoppio o esplosione</p>
          <p>- urto tra veicoli</p>
          <p>- caduta ascensori e montacarichi</p>
          <p>- furto di infissi</p>
          <p>- correnti, scariche o altri fenomeni elettrici</p>

          <p className="mt-3">Sono indennizzati, purche in conseguenza degli eventi di cui sopra:</p>
          <p className="mt-3">- i danni causati alle cose assicurate da sviluppo fumi e gas</p>
          <p>- i guasti causati allo scopo di impedire/arrestare l'incendio</p>
          <p>- le spese di demolizione e sgombero</p>
          <p>- i danni da perdita di pigione o mancato godimento del fabbricato</p>
          <p>- gli oneri di urbanizzazione</p>

          <p className="fw-bold mt-3">Responsabilità Civile verso Terzi</p>

          <p className="mt-3">- La Società solleva l'Assicurato di quanto questi sia tenuto a pagare a titolo di risarcimento di dani involontariamente cagionati a terzi, compresi i locatari, per morte, per lesioni personali e per danneggiamenti a cose ed animali, in conseguenza di un fatto accidentale verificatosi in relazione alla propietà del fabbricato.</p>

          <p className="fw-bold mt-3">Responsabilità Civile verso perstatori di lavoro</p>

          <p className="mt-3">- La Società solleva l'Assicurato di quanto questi debba pagare in quanto civilmente responsabile degli infortuni, della morte o delle lesioni personali occorsi ai suoi prestatori di lavoro.</p>

          <p className="fw-bold mt-3 fs-5">Garanzie Integrative Sempre Operanti</p>

          <p className="fw-bold mt-3">Danni ai beni:</p>
          <p className="mt-3">- parificazione danni incendio</p>
          <p>- fumo</p>
          <p>- spese peritali</p>
          <p>- anticipo indennizzi</p>
          <p>- colpa grave</p>
          <p>- caduta ascensori e montacarichi</p>
          <p>- buona fede</p>
          <p>- pannelli solari e fotovoltaici</p>
          <p className="fw-bold mt-3">RCT/O:</p>
          <p className="mt-3">- RC dell'amministratore</p>
          <p>- caduta neve e ghiaccio</p>
          <p>- pertinenze del fabbricato</p>
          <p>- committenza servizi di pulizia</p>
          <p>- inquinamento accidentale</p>

        </ModalContent>

      </ModalBody>
    </ProfessionInfoModalStyles>
  );
}

export default CondominioNobisModal;
